<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-button @click="_getList" type="primary" style="float: left;">搜索</el-button>
        <el-pagination background layout="prev, pager, next" :current-page="pageNum"
                       @current-change="pageChange"
                       :total="totalNum" v-if="paginationShow"></el-pagination>

      </div>
      <div class="categoryTable">
        <el-table ref="multipleTable" :data="balanceDatas" tooltip-effect="dark" style="width: 100%" border
        	>
        	<el-table-column type="selection" width="60">
        	</el-table-column>
        	<el-table-column prop="userName" label="关联用户" width="120">
        	</el-table-column>
        	<el-table-column prop="money" label="提现金额" width="110">
        	</el-table-column>
        	<el-table-column prop="serviceCharge" label="手续费" width="70">
        	</el-table-column>
        	<el-table-column prop="practical" label="实际到账金额" width="110">
        	</el-table-column>
        	<el-table-column prop="insertTime" label="提现时间" width="180">
        	</el-table-column>
        	<el-table-column prop="way" :formatter="handleWayValue" label="提现方式" width="80">
        	</el-table-column>
        	<el-table-column prop="cardNumbers" label="银行卡号" width="180">
        	</el-table-column>
        	<el-table-column prop="openingBank" label="开户行" width="200">
        	</el-table-column>
        	<el-table-column prop="cardUserName" label="开卡人" width="120">
        	</el-table-column>
        	<el-table-column prop="alipayAccount" label="银行卡关联手机号" width="120">
        	</el-table-column>
        	<el-table-column prop="alipayUserName" label="银行卡关联身份证号" width="180">
        	</el-table-column>
        	<el-table-column prop="remark" label="备注" width="140">
        	</el-table-column>
        	<el-table-column prop="refillTime" label="审批时间" width="180">
        	</el-table-column>
        	<el-table-column prop="state" :formatter="handleStatusValue" label="状态" width="100">
        	</el-table-column>
        	<el-table-column label="操作" width="160">
        		<template slot-scope="scope">
        			<el-button size="mini" @click="handleStatusDialog(scope.row, 1)" v-if="scope.row.state==0">同意
        			</el-button>
        			<el-button size="mini" @click="handleStatusDialog(scope.row, 2)" v-if="scope.row.state==0">驳回
        			</el-button>
        		</template>
        	</el-table-column>
        </el-table>
      </div>
      <!--      提示弹框-->
      <el-dialog title="提示" :visible.sync="statusDialogVisible" :append-to-body="true" width="20%" center>
      	<el-form label-width="80px" :model="reamrk">
      		<el-form-item label="备注">
      			<el-input v-model="remark"></el-input>
      		</el-form-item>
      	</el-form>
      	<span slot="footer" class="dialog-footer">
      		<el-button @click="statusDialogVisible = false">取 消</el-button>
      		<el-button type="primary" @click="changeStatus()">确 定</el-button>
      	</span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {Loading} from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getWithdrawDepositList, withdrawDepositAudit} from 'api/request'
import {ERR_OK} from 'api/config'
import {loadingInstance, Error} from 'common/js/util'

export default {
  components: {MSidebar, MHeader},
  data () {
    return {
      reamrk: null,
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      keywords: null,
      paginationShow: false,
      addDialogVisible: false,
      statusDialogVisible: false,
      addData: {},
      controlData: {},
      status: 0,
      remark: "",
      balanceDatas: [],
      multipleSelection: [],
      fileList: [{
      	name: 'food.jpeg',
      	url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
      }],
      topScrollWidth: 0,
      tableDom: null,
      choiceValue: ""
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'))
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    } else {
      this._getList()
    }
  },
  methods: {
    toggleSelection(rows) {
    	if (rows) {
    		rows.forEach(row => {
    			this.$refs.multipleTable.toggleRowSelection(row);
    		});
    	} else {
    		this.$refs.multipleTable.clearSelection();
    	}
    },
    handleSelectionChange(val) {
    	this.multipleSelection = val;
    },
    pageChange(val) {
    	console.log(val)
    	this.pageNum = val
    	this.balanceDatas = []
    	this._getList()
    },
    handleAdd() {
    	this.addDialogVisible = true;
    	this.addData = {};
    },
    handleWayValue(row, column, cellValue, index) {
    	if (cellValue == 1) {
    		return "银行卡";
    	} else if (cellValue == 2) {
    		return "支付宝";
    	}
    },
    changeStatus() {
    	if (this.status == 2) {
    		if (!this.remark) {
    			let res = {
    				message: "请填写备注！"
    			}
    			Error(this, res)
    			return;
    		}
    	}
    	let param = {
    		id: this.controlData.id,
    		state: this.status,
    		remark: this.remark
    	}
    	loadingInstance(Loading)
    	withdrawDepositAudit(param).then((res) => {
    		loadingInstance(Loading).close()
    		if (res.status === ERR_OK) {
    			this.statusDialogVisible = false;
    			// this.remark = ""
    			Success(this, res);
    			
    		} else {
    			Error(this, res)
    		}
        this._getList();
    	})
    },
    handleStatusValue(row, column, cellValue, index) {
    	//"state": 0,				//状态  0.待审核   1.审核通过   2.驳回
    	switch (cellValue) {
    		case 0:
    			return "待审核";
    		case 1:
    			return "审核通过";
    		case 2:
    			return "已驳回";
    	}
    },
    handleStatusDialog(row, status) {
    	this.statusDialogVisible = true;
    	this.controlData = row;
    	this.status = status;
    },
    handlePreview(file) {
    	console.log(file);
    },
    _getList() {
    	let param = {
    		current: this.pageNum,
    		size: this.pageSize,
    		content: this.keywords,
    		startDate: this.choiceValue[0],
    		endDate: this.choiceValue[1]
    	}
    	loadingInstance(Loading)
    	getWithdrawDepositList(param).then((res) => {
    		loadingInstance(Loading).close()
    		if (res.status === ERR_OK) {
    			this.balanceDatas = res.data.records
    			this.totalNum = res.data.total
    			if (res.data.pages > 1) this.paginationShow = true;
    		} else {
    			Error(this, res)
    		}
    	})
    	// this.setScrollWidth();
    },
  }
}
</script>
<style scoped>
  .userOperate{
    height: 50px;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 30px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

.userOperate .el-input {
    width:180px;
    margin-right: 10px;
    display: inline-block;
    float: left;
  }
  .userOperate .el-button {
    width:100px;
    display: inline-block;
    float: left;
    margin-right: 40px;
  }

.categoryOperate {
  height: 40px;
  margin: 20px;
  box-sizing: border-box;
}

.categoryTable {
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}
</style>
<style>
.el-tag + .el-tag {
  margin: 5px;
}

.categoryOperate .el-input {
  width: 180px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}

.categoryOperate .el-button {
  width: 100px;
  height: 40px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/finance/userWithdraw.vue